import { FieldComposer } from "./FieldComposer";
import { FieldLabel } from "./FieldLabel";
import { FieldUsage } from "./FieldUsage";
import { FormFieldConnector } from "./FormFieldConnector";
import { GenericExactness } from "./GenericExactness";
import { GenericField } from "./GenericField";
import { LimitedValuesField, NumberField, StringField, ValueRangeField, YearField } from "./basic-fields";
import { PlaceAutocompleteField } from "./basic-fields/PlaceAutocompleteField";
import { NameExactness, PlaceExactness, YearExactness } from "./field-exactness";
import { type FieldComposerConfig, FieldComposerExactnessType, FieldComposerFieldType } from "./types";
import { fieldToConfig } from "./utils/fieldToConfig";

FieldComposer.Label = FieldLabel;
FieldComposer.GenericField = GenericField;
FieldComposer.GenericExactness = GenericExactness;
FieldComposer.UsageText = FieldUsage;

FieldComposer.PlaceExactness = PlaceExactness;
FieldComposer.YearExactness = YearExactness;
FieldComposer.NameExactness = NameExactness;

FieldComposer.FieldConnector = FormFieldConnector;
FieldComposer.Inputs = {
    Number: NumberField,
    String: StringField,
    LimitedValues: LimitedValuesField,
    ValueRange: ValueRangeField,
    Year: YearField,
    Place: PlaceAutocompleteField,
};

export { FieldComposer, FieldComposerFieldType, FieldComposerExactnessType, fieldToConfig };
export type { FieldComposerConfig };
export { publishAddField, useOnAddField, publishRemoveField, useOnRemoveField } from "./events";
